export default "__VITE_ASSET__DtOetpTX__"